import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import { passwordService } from '../../../services/passwordService';
import logo from '../../../assets/Header/magnetix.png';
import './ForgotPassword.css';

const RequestOTP: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async () => {
    // Validation
    if (!email) {
      setError('Please enter your email address');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setIsLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await passwordService.forgotPassword(email);

      setSuccess(response.message || 'OTP sent successfully!');

      // Wait 1 second to show success message, then navigate
      setTimeout(() => {
        navigate('/verify-otp', { state: { email } });
      }, 1000);
    } catch (err: any) {
      setError(err.message || 'Failed to send OTP. Please try again.');
      console.error('Forgot password error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  return (
    <div className="request-otp-container">
      <div className="request-otp-header">
        <div className="request-otp-logo">
          <img src={logo} alt="Magnetix Logo" className="request-otp-logo-image" />
        </div>
      </div>

      <div className="request-otp-card">

        <h1 className="request-otp-title">Forgot Password?</h1>
        <p className="request-otp-subtitle">
          Enter your registered email address to receive an OTP
        </p>

        <div className="request-otp-form">
          {/* Error Message */}
          {error && (
            <div style={{
              padding: '12px',
              marginBottom: '16px',
              backgroundColor: '#FEE',
              border: '1px solid #EF4444',
              borderRadius: '8px',
              color: '#B91C1C',
              fontSize: '14px'
            }}>
              {error}
            </div>
          )}

          {/* Success Message */}
          {success && (
            <div style={{
              padding: '12px',
              marginBottom: '16px',
              backgroundColor: '#D1FAE5',
              border: '1px solid #10B981',
              borderRadius: '8px',
              color: '#065F46',
              fontSize: '14px'
            }}>
              {success}
            </div>
          )}

          <div className="request-otp-form-group">
            <label className="request-otp-label" htmlFor="email">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              className="request-otp-input"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError('');
                setSuccess('');
              }}
              placeholder=""
              disabled={isLoading}
            />
          </div>

          <button
            type="button"
            onClick={handleSubmit}
            className="request-otp-submit-button"
            disabled={isLoading}
          >
            {isLoading ? 'Sending...' : 'Send OTP'}
          </button>
        </div>

        <div className="request-otp-footer">
          Remember your password?{' '}
          <button
            type="button"
            onClick={handleBackToLogin}
            className="request-otp-login-link"
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
};

export default RequestOTP;
